import React, { useEffect, useRef, useState } from "react";
import { signInAsGuest, useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";

import FoldersAM from "../pages/folder_pages/FoldersAM.js";

import { getDocDataById, getDocDataByRef } from "../models/DataFunctions.js";

import "../animations/animations.css";

import { useSnackbar } from "notistack";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { Skeleton } from "@mui/material";

import EmailModal from "../modals/EmailModal.js";
import { useAppContext } from "../config/AppContext.js";
import deleteFolder from "../api/delete/deleteFolder.js";

import SmallSpinner from "../loading/SmallSpinner.js";

import PrimaryButton from "../buttons/PrimaryButton.js";

import { Input, Spin } from "antd";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Player } from "@lottiefiles/react-lottie-player";
import {
  sendAdminKey,
  sendSmsVerificationCall,
  VerifySmsCodeCall,
} from "../config/ApiCalls.js";
import sendErrorPaiementEmail from "../api/send/sendErrorPaiementEmail.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import TextField2 from "../textfields/TextField2.js";

function SmsPortal({ navigateWorkspace, impersonate = false }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const [searchParams] = useSearchParams();
  const redirect_url = searchParams.get("redirect_url");
  const auth_type = searchParams.get("auth_type");

  const [code, setCode] = useState("");
  const [step, setStep] = useState("waiting_button_clicked");

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [admin_open, setAdminOpen] = useState(null);
  const [admin_key, setAdminKey] = useState("");
  const [admin_code, setAdminCode] = useState("");
  // Initialize access states (all false by default) in the parent

  const [page_state, setPageState] = useState("start");

  // Add a ref to manage OTP focus
  const otpRef = useRef(null);

  // Add a state to trigger focus reset
  const [shouldFocusOTP, setShouldFocusOTP] = useState(false);

  const handleInitiateSession = async () => {
    try {
      if (impersonate === false) {
        if (auth_type === "folder") {
          // let folder = await getDocDataById("folder", id);
          // setFolderData(folder);
          // setReglementData(folder.reglement);
        }
        if (auth_type === "devis") {
          // let devis = await getDocDataById("devis", id);
          // setReglementData({
          //   infos: {
          //     phone: devis.tel_client.trim(),
          //   },
          // });
        }
        setPageState("auth1");
        setStep("waiting_button_clicked");
        setPageState("auth2");
      }
      // Fetch user data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSendSms = async (again = false) => {
    const infos = gatherDeviceInfo();
    setCode("");
    sendSmsVerificationCall(auth_type, id, infos, prefix);
    handleClickVariant(
      again
        ? "Un nouveau SMS de vérification a été envoyé"
        : "Un SMS de vérification a été envoyé",
      "success"
    );

    setStep("fill_code");
    setShouldFocusOTP(true);
  };

  const handleSendAdminKey = async () => {
    const infos = gatherDeviceInfo();
    sendAdminKey(admin_key, id, prefix);
    setAdminOpen(2);
    handleClickVariant("Clé envoyée", "success");
  };

  const handleSendAdminCode = async (event) => {
    event && event?.preventDefault();
    try {
      let admin_code_str = admin_code.toString();
      let res = await VerifySmsCodeCall(auth_type, id, admin_code_str, prefix);
      if (res.success) {
        handleClickVariant("Code SMS correct", "success"); // Success notification
        const data = {
          creation_date: new Date(),
        };
        let usr = await signInAsGuest(res.token);
        if (redirect_url) {
          navigateWorkspace(redirect_url);
        }
      } else {
        handleClickVariant("Code SMS incorrect", "error"); // Error notification
        setAdminOpen(null);
      }
    } catch (error) {
      handleClickVariant("Code SMS incorrect", "error"); // Error notification
      console.error("Error logging in:", error.message);
      setAdminOpen(null);
    }
  };

  const [loadingVerification, setLoadingVerification] = useState(false);

  const handleVerifyCode = async (code) => {
    console.log("handleVerifyCode called with code:", code);

    try {
      setLoadingVerification(true);
      let code_str = code.toString();
      let res = await VerifySmsCodeCall(auth_type, id, code_str, prefix);
      if (res.success) {
        handleClickVariant("Code SMS correct", "success"); // Success notification
        const data = {
          creation_date: new Date(),
        };
        await signInAsGuest(res.token);
        if (redirect_url) {
          navigateWorkspace(redirect_url);
        }
      } else {
        handleClickVariant("Code SMS incorrect", "error"); // Error notification
        setCode("");

        setTimeout(async () => {
          await handleSendSms(true); // Resend SMS verification
        }, 1000); // Wait for 2 seconds before resending
      }
    } catch (error) {
      handleClickVariant("Code SMS incorrect", "error"); // Error notification
      console.error("Error logging in:", error.message);
      setCode("");
      setPageState("auth1");
      await handleSendSms(true);
    }
    setLoadingVerification(false);
  };

  // useEffect for focusing the OTP input
  useEffect(() => {
    if (shouldFocusOTP && otpRef.current) {
      otpRef.current.focus();
      setShouldFocusOTP(false); // Reset the focus state
    }
  }, [shouldFocusOTP]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key === "p") {
        console.log("catched alt p")
        if (admin_open === null) {
          console.log("set admin open to 1")
          setAdminOpen(1);
        } else {
          setAdminOpen(null);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [admin_open]);

  const [initiated, setInitiated] = useState(false);
  useEffect(() => {
    if (!loading) {
      if (!impersonate) {
        handleInitiateSession(); // Fetch user data when currentUser is available
      }
    }
  }, [currentUser, loading]); // Dependency array ensures this runs when currentUser changes

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  function hideParttially(str) {
    return str.slice(0, 3) + "****" + str.slice(-3);
  }

  if (page_state === "start") {
    return (
      <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <SmallSpinner />
        </div>{" "}
      </div>
    );
  }

  if (page_state === "auth1") {
    return (
      <div className="relative bg-neutral-100 flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        {admin_open && (
          <div className="absolute top-10 right-3 flex flex-row gap-2">
            {admin_open === 1 && (
              <>
                <TextField2
                  value={admin_key}
                  onChange={(e) => setAdminKey(e.target.value)}
                  label="Clé admin"
                ></TextField2>
                <PrimaryButton onClick={handleSendAdminKey}>
                  Valider
                </PrimaryButton>
              </>
            )}

            {admin_open === 2 && (
              <>
                <TextField2
                  value={admin_code}
                  onChange={(e) => setAdminCode(e.target.value)}
                  label="Code admin"
                ></TextField2>
                <PrimaryButton onClick={handleSendAdminCode}>
                  Valider
                </PrimaryButton>
              </>
            )}
          </div>
        )}
        <div className="flex flex-col w-fit h-fit p-8 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <SmallSpinner></SmallSpinner>
        </div>
      </div>
    );
  }

  const props = {
    renderInput: (props) => (
      <input
        {...props}
        autocomplete="one-time-code"
        name="otp"
        inputMode="numeric" // Ensures numeric keyboard on mobile
      />
    ),
  };

  if (page_state === "auth2") {
    return (
      <div className="relative flex flex-col w-full h-full bg-indigo-300   overflow-auto align-middle items-center justify-center">
        {admin_open && (
          <div className="absolute top-10 right-3 flex flex-row gap-2">
            {admin_open === 1 && (
              <>
                <TextField2
                  value={admin_key}
                  onChange={(e) => setAdminKey(e.target.value)}
                  label="Clé admin"
                ></TextField2>
                <PrimaryButton onClick={handleSendAdminKey}>
                  Valider
                </PrimaryButton>
              </>
            )}

            {admin_open === 2 && (
              <>
                <TextField2
                  value={admin_code}
                  onChange={(e) => setAdminCode(e.target.value)}
                  label="Code admin"
                ></TextField2>
                <PrimaryButton onClick={handleSendAdminCode}>
                  Valider
                </PrimaryButton>
              </>
            )}
          </div>
        )}
        <div className="flex flex-col w-fit  h-fit p-8 gap-2 mx-2 bg-wshadow_50 border border-white rounded-3xl shadow-md overflow-auto items-center">
          <Icon1 icon_name="lock" fill="black" />
          {step === "waiting_button_clicked" && (
            <>
              <div className="text-h2 font-medium text-center max-w-c250 w-full">
                Sécurité SMS
              </div>
              <div className="text-h3 text-shadow_50 text-center mb-4 ">
                Cliquez pour recevoir le code
              </div>

              <div className="flex flex-row gap-2">
                <PrimaryButton onClick={() => handleSendSms()} big={true}>
                  Recevoir le code
                </PrimaryButton>
              </div>
            </>
          )}
          {step === "fill_code" && (
            <>
              <div className="text-h2 font-medium text-center max-w-c250 w-full">
                Entrez le code de vérification
              </div>
              <div className="text-h3 text-shadow_50 text-center ">
                Nous avons envoyé le code par SMS
              </div>
              <div className="w-full max-w-c250 my-2">
                <Input.OTP
                  ref={otpRef}
                  {...props}
                  value={code}
                  type="number"
                  onChange={(e) => {
                    setCode(e);
                    if (e.length === 5) {
                      handleVerifyCode(e);
                    }
                  }}
                  autoFocus={true}
                  numberOfInputs={5}
                  length={5}
                />
              </div>

              <div className="flex flex-row gap-2">
                {/* <SecondaryButton onClick={() => setPageState("auth1")}>
              Retour
            </SecondaryButton> */}
                {/* <PrimaryButton
              disabled={code.length < 5 || loadingVerification}
              onClick={handleVerifyCode}
              big={true}
            >
              Vérifier le code 
            </PrimaryButton> */}
                {loadingVerification && <SmallSpinner />}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default SmsPortal;
